import SearchIcon from '@mui/icons-material/Search';
import { Box, Divider, Grid, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IsSmallScreen } from '../../commonFunctions/CommonFunctions';

interface IFilterSearchTextProps {
    rows: IRows;
    onFilterChange: (filters: IFilter[]) => void;
    alignment?: 'left' | 'center' | 'right';
    defaultFilter?: any[]
}

export interface IRows {
    fieldName?: string;
}

interface IFilter {
    field: string;
    operator: Operator | string;
    value: string | number;
}

export enum Operator {
    EqualTo = 'eq',
    NotEqualTo = 'neq',
    GreaterThan = 'gt',
    LessThan = 'lt',
    Like = 'like',
}

export const FilterSearchTextNew: React.FC<IFilterSearchTextProps> = React.memo(({ rows, onFilterChange, alignment = 'left', defaultFilter }) => {
    const methods = useForm();
    const { register, handleSubmit, control, reset } = methods;
    const isMobile = IsSmallScreen();

    const handleReset = () => {
        reset(); // ✅ Correct way to reset form
        onFilterChange([]); // Clear filters
    };

    const onSubmit = (data: Record<string, any>) => {

        console.log('try to search please wait',data)
        if (data.searchAll === undefined) {
            handleReset()
        }
        if (!rows || !rows.fieldName) {
            console.warn("No field names found in rows.");
            return;
        }

        // ✅ Correct usage of `reduce()`
        // const appliedFilters: any[] = (rows.fieldName || []).reduce((acc: any[], field) => {
        //     if (data.searchAll!== "") { // Ensure valid input
        //         acc.push({
        //             field: rows.fieldName,
        //             operator: Operator.Like, // ✅ Use `Operator.EqualTo` if needed
        //             value: data.searchAll , // ✅ Uses actual field value
        //         });
        //     }
        //     return acc;
        // }, []);
        const appliedFilters: any[] = []
        if (defaultFilter && defaultFilter.length > 0) {
            appliedFilters.push(...defaultFilter)
        }
        if (data.searchAll && data.searchAll !== "") {
            appliedFilters.push({
                field: rows.fieldName,
                operator: Operator.Like, // ✅ Use `Operator.EqualTo` if needed
                value: data.searchAll, // ✅ Uses actual field value
            });
        }
        onFilterChange(appliedFilters);
    };


    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Divider sx={{ marginLeft: 1 }} />

                <Grid container spacing={2} sx={{ margin: 1 }}>

                    <Grid item sm={12}>
                        <Box sx={{ flexGrow: 1 }}>
                            <TextField
                                id="searchAll"
                                size="small"
                                {...register('searchAll')}
                                name="searchAll"
                                label="" // Remove the floating label for a cleaner look
                                placeholder="Search"
                                variant="outlined"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon fontSize="small" sx={{ color: '#9CA3AF' }} />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    width: '100%',
                                    backgroundColor: '#F5F7FA',
                                    borderRadius: '25px', // pill shape
                                    
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '25px',
                                        paddingRight: 1,
                                        '& fieldset': {
                                            borderColor: '#098963', // light gray
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#9CA3AF', // darker on hover
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#3B82F6', // primary on focus
                                        },
                                    },
                                    '& .MuiInputBase-input': {
                                        padding: '8px 14px',
                                        fontSize: '0.875rem',
                                    },
                                }}
                            />
                        </Box>

                    </Grid>
                </Grid>
            </form>
        </FormProvider>
    );
});
